'use client'

import { Fragment, useState, useMemo, useRef } from "react";
import { CN_PRODUCT } from "@/utils/const";
import Player from "@/components/player";
import dynamic from 'next/dynamic';
// styles
import { ImageShowWrapper } from "@/styles/product";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
import { useParams } from "next/navigation";
type MediaProps = {
    isVideo: boolean
    targetSrc: string,
    index: number | string;
}

const CDNImage = dynamic(() => import("../cdnImage/cdnImage"), { ssr: false });
const Follow = dynamic(() => import('@/components/product/follow'), { ssr: false })

export default function ImgShowZone({ imagePartList, videoPartList, followState }: any) {
    const imgData = (videoPartList || []).concat(imagePartList || [])
    const [errorStack, setErrorStack] = useState<Record<string, string>>({})
    const [activeThumbnail, setActiveThumbnail] = useState<Record<number | string, MediaProps>>(()=> {
        const videoSrc = imgData[0]?.["C-P#video&video"]?.videoUrl
        const isVideo = !!videoSrc
        return {
            0: {
                index: 0,
                isVideo,
                targetSrc: isVideo ? videoSrc : imgData[0]?.["C-P#image&image"]?.imageUrl
            }
        }
    })
    const { sku } = useParams<{sku: string}>()
    const onThumbnailChange = (index: number, isVideo: boolean, targetSrc: string)=> {
        setActiveThumbnail({
            [index]: {
                index,
                isVideo,
                targetSrc
            }
        })
        sendClickTrack.Productdetail_MainPicture_Click({
            mainskuid: sku,
            madiaType: isVideo ? "video" : "picture",
            index
        })
    }
    const activeProps = useMemo(()=> {

        return { show: !errorStack[Object.keys(activeThumbnail)?.[0]], ...(Object.values(activeThumbnail)?.[0] || {})}
    }, [activeThumbnail, errorStack])

    const onImageError = (index: number | string)=> {
        setErrorStack((prevErrorStack)=> ({...prevErrorStack, [index]: index}))
    }

  return (
    <ImageShowWrapper>
      <div className={CN_PRODUCT("thumbnails-list")}>
        {imgData.map((item: any, index: number) => {

            const videoCoverImgSrc = item["C-P#video&video"]?.coverImageUrl
            const videoSourceSrc = item["C-P#video&video"]?.videoUrl

            const isVideo = !!videoCoverImgSrc

            const imgSrc = videoCoverImgSrc || item["C-P#image&image"]?.imageUrl

            // supplementaryImageList
            const supplementaryImageList = item["C-P#image&image"]?.supplementaryImageList
            return <Fragment key={index}><div className={`${CN_PRODUCT("thumbnail")} ${!!activeThumbnail[index] ? "active" : ""}`} onClick={()=> onThumbnailChange(index, isVideo, isVideo ? videoSourceSrc : imgSrc )}>
                {isVideo && <div className="player-tag-icon">Video</div>}
                <CDNImage src={imgSrc} width={112} height={112} alt="thumbnail" onError={()=> onImageError(index)}/>
            </div>
                {supplementaryImageList?.map((picUrl: string, index2: number)=> {
                    const keyIndex = index + '-' + index2
                    return <div className={`${CN_PRODUCT("thumbnail")} ${!!activeThumbnail[keyIndex] ? "active" : ""}`} key={keyIndex} onClick={()=> onThumbnailChange(keyIndex, false, picUrl )}>

                        <CDNImage src={picUrl} width={112} height={112} alt="thumbnail" onError={()=> onImageError(keyIndex)}/>
                    </div>
                })}
            </Fragment>
        })}
      </div>
        <div 
            className="media-content"
            exptag={"exp|" + EXPOSURE_RECORD.Productdetail_MainPicture_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={
                JSON.stringify({
                  mainskuid: sku,
                  madiaType: activeProps.isVideo ? "video" : "picture",
                  index: activeProps?.index || 0
                })
              }
        >
            {
                activeProps.isVideo ? <Player
                    url={`${activeProps.targetSrc}`}
                    width={624}
                    height={624}
                    onPlayTrack={(status)=> {
                        sendClickTrack.Productdetail_BigVideo_Click({
                            mainskuid: sku,
                            playStatus: status
                        })
                    }}
                /> :  <div className={CN_PRODUCT("big-img")}>

                    {activeProps.show && <CDNImage src={activeProps.targetSrc} width={624} height={624} alt="thumbnail" />}
                </div>
            }
            <Follow followState={followState}/>
        </div>
    </ImageShowWrapper>
  );
}
